import moment from 'moment/moment';
import { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import Barcode from 'react-barcode';
import useSWR from 'swr';
import { URLS } from '../../../services/urls';
import _ from 'lodash'
import { formatNumber } from '../../../components/utils/functions';

const SupplyTicket = ({ invoice, isSelledHistory }) => {
  const [toShow, setToShow] = useState();
  const [dimensions, setDimensions] = useState({ width: 100, height: 500 });
  const { data: inv, isLoading, mutate } = useSWR(URLS.INVOICES.details(invoice?.id));

  const ticketRef = useRef();

  const handlePrint = useReactToPrint({
    pageStyle: `@media print {
            @page {
              size: ${dimensions.width}mm ${dimensions.height}mm;
              margin: 0;
            }
          }`,
    content: () => ticketRef?.current,
    documentTitle: 'Facture ' + inv?.reference,
    // onBeforeGetContent: () => setHideButton(true),
    // onAfterPrint: () => setHideButton(true)
  });

  useEffect(() => {
    var elem = document.getElementById("invoiceTicket");
    if(elem) {
      var rect = elem.getBoundingClientRect();
      setDimensions(prev => {
          return {
              "height": rect.width * 0.4645833,
              "width": 90,
          }
      })

    }
  }, []);
  return (
    <div>
     {invoice && <div className="row">
        <div className="col-md-1 col-2"></div>
        <div className="col-md-10 col-8 text-center">
          <div className="d-flex">
            <div className="m-auto" style={{width: '100%'}}>
              <div className="mb-3 border-md-3 border p-3" ref={ticketRef} id='invoiceTicket'>
                <div className="row">
                  <div className="col-12">
                    <div>
                      <img
                        src="/assets/images/logo-dark.webp"
                        alt=""
                        height="70"
                        className=" mx-auto"
                      /> <br />
                      <p className="">INSTITUT DE BIEN - ETRE - COIFFURES - SOINS CORPORELS - MASSAGE - ESPACE DETENTE</p>
                      <span>
                        <strong>RCCM</strong>: RC/DLN/2021/B/652
                      </span>
                      <span className='ms-2'><strong>NIU</strong>: M022118505410B </span>
                      
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="">
                      {
                        Object.values(invoice)[0][0]?.side === "IN" ?
                          <p className="mb-1 text-center">
                            <span>
                              <strong>Date d'achat:</strong> {moment(invoice[Object.keys(invoice)[0]][0]?.date).format('DD/MM/YYYY')}
                            </span>
                            <span className='ms-2'>
                              <strong>Date de saisie:</strong> {moment(invoice[Object.keys(invoice)[0]][0]?.created_at).format('DD/MM/YYYY')}
                            </span>
                          </p> :
                          <p className="mb-1 text-center">
                            <span>
                              <strong>Date de sortie:</strong> {moment(invoice[Object.keys(invoice)[0]][0]?.created_at).format('DD/MM/YYYY')}
                            </span>
                            <span className='ms-2'>
                              <strong>Emplacement: </strong> {Object.values(invoice)[0][0].location.name}
                            </span><br />
                            {Object.values(invoice)[0][0].beneficiary && <span className='ms-2'>
                              <strong>Bénéficiaire: </strong> {Object.values(invoice)[0][0].beneficiary}
                            </span>}<br />
                            {Object.values(invoice)[0][0].reason && <span className='ms-2'>
                              <strong>Motif: </strong> {Object.values(invoice)[0][0].reason}
                            </span>}
                          </p>
                      }
                    </div>
                  </div>
                  <div className="col-12  text-center">
                    <div>
                      {Object.values(invoice)[0][0].side === "IN" && <p className="mb-1 text-center">
                        
                        <span>
                          <strong>Fournisseur: </strong> {Object.values(invoice)[0][0].supplier} (<strong> Nᵒ Fact: </strong> {Object.keys(invoice)[0]})
                        </span><br />
                        <span className='ms-2'>
                          <strong>Emplacement: </strong> {Object.values(invoice)[0][0].location.name}
                        </span>
                      </p>}
                      <br />
                      <h4 className='text-black fw-bold text-uppercase'>
                        {
                          Object.values(invoice)[0][0].side === "IN" && "Bon d'approvisionnement"
                        } 
                        {(Object.values(invoice)[0][0].side === "OUT" && "Bon de déstockage")}
                      </h4>
                    </div>
                    <hr style={{borderTop: "dotted 2px"}} />
                    <div className='teble-responsive'>
                        
                        <table className="table align-middle table-hover table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="text-uppercase">Désignation{invoice[Object.keys(invoice)[0]]?.length > 1 ? "s" : ""}</th>
                      <th className="text-uppercase">Qte</th>
                      {
                        (isSelledHistory && Object.values(invoice)[0][0]?.for_sell) &&
                        <>
                          <th className="text-uppercase">PV Unit</th>
                          <th className="text-uppercase">TOTAL</th>
                        </>
                      }
                      <th className="text-uppercase">
                        {
                          !Object.values(invoice)[0][0]?.for_sell ? "CMUP" : "Prix d'achat"
                        }
                      </th>
                      {
                        (isSelledHistory && Object.values(invoice)[0][0]?.for_sell) ? <>
                        <th className="text-uppercase">Marge</th>
                        </> :
                        <th className="text-uppercase">Total</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                  {
                            invoice[Object.keys(invoice)[0]]?.map((item) => (
                                <tr>
                                    <td>{item?.product?.title}</td>
                                    <td>{item?.quantity}</td>
                                    {
                                      (isSelledHistory && Object.values(invoice)[0][0]?.for_sell) && 
                                        <td>{formatNumber(item?.sell_price)}</td>
                                    }
                                    {(Object.values(invoice)[0][0]?.for_sell) &&<td>{formatNumber(Number(item?.sell_price) * item?.quantity)}</td>}
                                    <td>{formatNumber(item?.cmup)}</td>
                                    {
                                      (isSelledHistory && Object.values(invoice)[0][0]?.for_sell) ? <>
                                      <td>{formatNumber(Number(item?.sell_price - item?.cmup) * item?.quantity)}</td>
                                      </>
                                      : 
                                      <td>
                                          {formatNumber(
                                            item?.quantity * item?.cmup
                                          )}
                                      </td>
                                    }
                                </tr>
                            ))
                        }
                  </tbody>
                  </table>
                    </div>
                    <hr style={{borderTop: "dotted 2px"}} />
                    <div>
                        <Barcode height={50} value={
                          (Object.values(invoice)[0][0]?.side == "IN" || !Object.values(invoice)[0][0]?.for_sell) ?
                          Object.values(invoice)[0][0]?.reference :
                          Object.values(invoice)[0][0]?.designation
                        } width={1} />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="ms-auto">
                        <span className="small">Imprimé le: {moment().format("DD/MM/YYYY HH:MM")}</span>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          {Object.values(invoice)[0][0]?.side === "IN" && <div>
            <button
              type="button"
              className="btn btn-primary waves-effect waves-light"
              onClick={handlePrint}
            >
              {' '}
              Imprimer 
            </button>
          </div>}
        </div>
        <div className="col-md-2 col-2"></div>
      </div>}
    </div>
  );
};

export default SupplyTicket;
